import React, { useContext, useEffect } from'react'
import styled from 'styled-components'
import gsap from 'gsap'
import { EventView, MenuTitle } from './SavedMenu/index'

import { SavedTripsContext } from '../utils/savedTripsContext'
import activities from '../data/activities'
import t from '../data/en'

const MobileMenuView = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  opacity: 0;
  z-index: 400;
  overflow: hidden;
`

const Background = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  transform: translate(0, -100%);
  background-color: #04AAB2;
  z-index: 300;
`

const SavedEventsMenuMobile = ({ isOpen, closeMenu, closeSavedEventsMenu }) => {
  const { savedTrips, setSavedTrips } = useContext(SavedTripsContext)

  const removeActivty = (id) => {
    setSavedTrips(savedTrips.filter(trip => trip !== id))
  }

  useEffect(() => {
    if(isOpen) {
      gsap.set('.mobile-event-menu', {
        width: '100vw',
        height: '100vh',
      })

      gsap.to('.mobile-event-bg', { y: 0, duration: .3 })

      gsap.to('.mobile-event-menu', {
        opacity: 1,
        duration: .5
      })
    }

    if(!isOpen) {
      gsap.to('.mobile-event-bg', { y: '-100%', duration: .3 })
      gsap.to('.mobile-event-menu', {
        opacity: 0,
        duration: .5,
        onComplete: () => {
          gsap.set('.mobile-event-menu', {
            width: 0,
            height: 0,
          })
        }
      })
    }
  }, [isOpen])

  return (
    <>
      <MobileMenuView className='mobile-event-menu'>
        <MenuTitle>{t.menu.your_choices}:</MenuTitle>
        {savedTrips.map(trip => {
            return <EventView
              key={`saved-menu-${trip}`}
              removeActivty={removeActivty}
              {...activities.find(activity => activity.id === trip)}
            />
          })}
      </MobileMenuView>
      <Background className='mobile-event-bg'/>
    </>
  )
}
export default SavedEventsMenuMobile
